import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Offcanvas from "react-bootstrap/Offcanvas";
import LogoT2m from "../../assets/img/logo_t2m.png";
import LogoT2mWhite from "../../assets/img/logo_t2m_white.png";

import { AiOutlineTable, AiOutlineIdcard } from "react-icons/ai";
import { CgHome } from "react-icons/cg";
import { TbIcons } from "react-icons/tb";
import { HiOutlineColorSwatch } from "react-icons/hi";
import { FaWpforms } from "react-icons/fa";
import { BsArrowBarLeft } from "react-icons/bs";
import { CgMenuRound } from "react-icons/cg";
import { BiUserCircle } from "react-icons/bi";
import {
  MdContrast,
  MdOutlineExitToApp,
  MdOutlineTextDecrease,
  MdOutlineTextIncrease,
} from "react-icons/md";
import {
  SidebarMobileStyle,
  SidebarMobileNavStyle,
  LogoArea,
  CloseIconArea,
} from "./style.js";

function SidebarMobile({
  logOut,
  HandledarkMode,
  isDarkMode,
  decreaseFontSize,
  increaseFontSize,
}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate();

  function navigateTo(route) {
    setShow(false);
    window.scrollTo(0, 0);
    navigate(route);
  }

  const RenderSystemLogo = () => {
    return isDarkMode ? (
      <img
        src={LogoT2mWhite}
        alt="T2M"
        style={{ cursor: "pointer" }}
        onClick={() => navigateTo("/")}
      />
    ) : (
      <img
        src={LogoT2m}
        alt="T2M"
        style={{ cursor: "pointer" }}
        onClick={() => navigateTo("/")}
      />
    );
  };

  const SideBarMobileItem = ({ title, icon, action }) => {
    return (
      <div className="sidebar-nav-item">
        <div onClick={action}>
          <div className="area-icons-label">
            {icon}
            <span>{title}</span>
          </div>
        </div>
      </div>
    );
  };

  const UserInfo = () => {
    return (
      <div className="user-container mt-3">
        <BiUserCircle />
        <div className="user-info">
          <span title="User" className="label-sidebar">
            Breno M.
          </span>
          <span
            id="user-department"
            className="label-sidebar"
            title="Departamento Pessoal"
          >
            Departamento pessoal
          </span>
        </div>
      </div>
    );
  };

  return (
    <SidebarMobileStyle>
      <Row>
        <Col className="px-0 col">
          <div className="button-show-area">
            <div className="button-show">
              <CgMenuRound onClick={handleShow} />
            </div>
            <div className="central-area">{RenderSystemLogo()}</div>
            <div className="right-area">
              <BiUserCircle />
            </div>
          </div>
          <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Header
              style={{ backgroundColor: "var(--branco-primario)" }}
            >
              <Offcanvas.Title>
                <LogoArea>
                  <div className="area-central">{RenderSystemLogo()}</div>
                  <span>Sistema de Padronização de Layouts</span>
                </LogoArea>
              </Offcanvas.Title>
              <CloseIconArea>
                <BsArrowBarLeft onClick={handleClose} />
              </CloseIconArea>
            </Offcanvas.Header>
            <Offcanvas.Body
              style={{ backgroundColor: "var(--branco-primario)" }}
            >
              <SidebarMobileNavStyle>
                <div className="flex-column sidebar-mobile-nav">
                  <SideBarMobileItem
                    title={"Alto Contraste"}
                    icon={<MdContrast title="Alto Contraste" size={28} />}
                    action={HandledarkMode}
                  />
                  <SideBarMobileItem
                    title={"Aumentar Fonte"}
                    icon={
                      <MdOutlineTextIncrease title="Aumentar Fonte" size={28} />
                    }
                    action={increaseFontSize}
                  />

                  <SideBarMobileItem
                    title={"Diminuir Fonte"}
                    icon={
                      <MdOutlineTextDecrease title="Diminuir Fonte" size={24} />
                    }
                    action={decreaseFontSize}
                  />
                </div>
                <div className="flex-column sidebar-mobile-nav">
                  <SideBarMobileItem
                    title={"Início"}
                    icon={<CgHome />}
                    action={() => navigateTo("/")}
                  />
                  <SideBarMobileItem
                    title={"Tabela"}
                    icon={<AiOutlineTable />}
                    action={() => navigateTo("/tabela")}
                  />
                  <SideBarMobileItem
                    title={"Componentes"}
                    icon={<AiOutlineIdcard />}
                    action={() => navigateTo("/cards")}
                  />
                  <SideBarMobileItem
                    title={"Paleta de cores"}
                    icon={<HiOutlineColorSwatch />}
                    action={() => navigateTo("/paletacores")}
                  />
                  <SideBarMobileItem
                    title={"Ícones"}
                    icon={<TbIcons />}
                    action={() => navigateTo("/botoes")}
                  />
                  <SideBarMobileItem
                    title={"Formulários"}
                    icon={<FaWpforms />}
                    action={() => navigateTo("/formularios")}
                  />
                </div>

                <UserInfo />

                <div className="sidebar-mobile-nav">
                  <div className="sidebar-nav-item mt-3">
                    <div onClick={() => logOut()}>
                      <div className="area-icons-label">
                        <MdOutlineExitToApp />
                        <span>Sair</span>
                      </div>
                    </div>
                  </div>
                </div>
              </SidebarMobileNavStyle>
            </Offcanvas.Body>
          </Offcanvas>
        </Col>
      </Row>
    </SidebarMobileStyle>
  );
}

export default SidebarMobile;
